import type { PaymentChannel } from '@festina/moneyout-general-types/moneyout'
import { CircularSpinner } from '@festina-life/ui/feedback'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import { ErrorBoundary } from 'react-error-boundary'

import { useLazyFetchPaymentChannelBankAccount } from '../../../hooks/useLazyFetchPaymentChannelBankAccount'
import { useService } from '../../../lenteHooks'
import { ErrorMessage } from '../../errorFallback/ErrorMessage'
import { LifeErrorFallback } from '../../errorFallback/LifeErrorFallback'

type Props = {
  paymentChannel: PaymentChannel
  showBankAccountType?: boolean
}
export const BankAccountDetails = ({
  paymentChannel,
  showBankAccountType = false,
}: Props) => {
  const translateEnum = useTranslateEnum()

  const formatBankAccount = useService(
    'formatter.paymentChannelBankAccountFormatter',
  )
  const { resolvedPaymentChannel, error, isLoading } =
    useLazyFetchPaymentChannelBankAccount(paymentChannel)

  const bankAccountType = showBankAccountType
    ? translateEnum('moneyOut.enum.PaymentChannel', paymentChannel?._type)
    : ''

  if (isLoading) {
    return <CircularSpinner className="size-3" />
  }
  return (
    <ErrorBoundary FallbackComponent={LifeErrorFallback}>
      <ErrorMessage error={error} />
      {[bankAccountType, formatBankAccount(resolvedPaymentChannel, '-')].join(
        ' ',
      )}
    </ErrorBoundary>
  )
}
